import * as types from './actionTypes'

export default {
  [types.UPDATE_TAB_COLUMN](state, { type, payload }) {
    state.tree[type] = Object.freeze(payload)
  },

  [types.ADD_TO_QUERY](state, { type, payload }) {
    const alreadyAdded = state.query[type].find(
      ({ path }) => path === payload.path.replace('county-', '')
    )

    if (alreadyAdded) {
      return false
    }

    if (type === 'languages') {
      state.query.languages = [
        ...state.query.languages,
        {
          name: payload.name,
          path: payload.path
        }
      ]

      return
    }

    state.query[type] = [
      ...state.query[type],
      {
        name: payload.name,
        path: payload.path.replace('county-', ''),
        years: payload.years ? payload.years : []
      }
    ]
  },

  [types.REMOVE_FROM_QUERY](state, { type, path, subject, value }) {
    if (type === 'asylumStatus') {
      state.query.asylumStatus = state.query.asylumStatus.filter(x => {
        return x[path] === undefined || x[path] !== value
      })

      return
    }

    if (type === 'educations') {
      if (subject && subject.path) {
        state.query.educations = state.query.educations.filter(education => {
          return (
            education.path !== path || education.subject.path !== subject.path
          )
        })
      } else {
        state.query.educations = state.query.educations.filter(
          education => education.path !== path
        )
      }

      return
    }

    state.query[type] = state.query[type].filter(x => x.path !== path)
  },

  [types.CLEAR_FROM_QUERY](state, type) {
    state.query[type] = []
  },

  [types.CLEAR_QUERY_OF_TYPE](state, { type, path }) {
    state.query[type] = state.query[type].filter(x => {
      const innerPath = x.path.split('.')
      const inputPath = path.replace('county-', '').split('.')

      switch (inputPath.length) {
        case 3:
          return (
            innerPath.slice(0, 3).join('.') !== inputPath.slice(0, 3).join('.')
          )
        case 2:
          return (
            innerPath.slice(0, 2).join('.') !== inputPath.slice(0, 2).join('.')
          )
        case 1:
          return innerPath[0] !== inputPath[0]
      }
    })
  },

  [types.RESET_QUERY](state) {
    state.query = {
      city: [],
      skills: [],
      experiences: [],
      educations: [],
      languages: [],
      asylumStatus: []
    }
  },

  [types.ADD_SKILL_YEARS](state, payload) {
    const { name, years } = payload

    const foundSkill = state.query.skills.filter(
      ({ path }) => path !== payload.path
    )

    state.query.skills = [
      ...foundSkill,
      {
        name,
        path: payload.path,
        years
      }
    ]
  },

  [types.ADD_EXPERIENCE_YEARS](state, payload) {
    const { name, years } = payload

    const foundExperience = state.query.experiences.filter(
      ({ path }) => path !== payload.path
    )

    state.query.experiences = [
      ...foundExperience,
      {
        name,
        path: payload.path,
        years
      }
    ]
  },

  [types.ADD_EDUCATION_TO_QUERY](state, { payload }) {
    const alreadyAddedLevelPath = state.query.educations.find(
      ({ path }) => path === payload.path
    )

    const alreadyAddedSubjectPath = state.query.educations.find(
      ({ subject: { path } }) => path === payload.subject.path
    )

    if (alreadyAddedLevelPath && alreadyAddedSubjectPath) {
      return false
    }

    state.query.educations = [...state.query.educations, payload]
  },

  [types.SET_RESULTS](state, payload) {
    state.results = payload
    state.hasSearched = true
    state.noResults = false
    state.error = false
  },

  [types.SET_NO_RESULTS](state) {
    state.results = {
      hits: [],
      total: 0
    }
    state.noResults = true
    state.error = false
  },

  [types.SET_RESULT_ERROR](state, error) {
    state.results = {
      hits: [],
      total: 0
    }
    state.error = error
    state.noResults = true
    state.hasSearched = true
  },

  [types.LOG_IN](state) {
    state.loggedIn = true
  },

  [types.LOG_OUT](state) {
    state.loggedIn = false
  },

  [types.SET_ACTIVE_TAB](state, payload) {
    state.activeTab = payload === state.activeTab ? '' : payload
  },

  [types.SET_ACTIVE_TAB_ONLY](state, payload) {
    state.activeTab = payload
  },

  [types.SET_SKIP](state, payload) {
    state.skip = (payload - 1) * 10
  },

  [types.HAS_RESIDENCE_PERMIT](state) {
    const input = {
      hasResidencePermit: true
    }

    state.query.asylumStatus = state.query.asylumStatus.concat([input])
  },

  [types.HAS_WORK_PERMIT](state) {
    const input = {
      hasAtUnd: true
    }

    state.query.asylumStatus = state.query.asylumStatus.concat([input])
  },

  [types.NO_WORK_PERMIT](state) {
    const input = {
      hasAtUnd: false
    }

    state.query.asylumStatus = state.query.asylumStatus.concat([input])
  },

  [types.SET_SORT](state, payload) {
    state.sort = payload
  },

  [types.OPEN_MODAL](state, payload) {
    state.modal = payload
  },

  [types.CLOSE_MODAL](state) {
    state.modal = ''
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js